import {
	createStyles,
} from '@mui/styles';
import {
	alpha,
	Theme,
} from '@mui/material/styles';
// Import enumerations.
import {
	BreakpointWidth,
} from '@app/enumerations';

const styles = (theme: Theme) => {
	return createStyles({
		slideView_container: {
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				position: 'fixed',
				zIndex: theme.zIndex.tooltip,
			},
			[theme.breakpoints.up(BreakpointWidth.LARGE)]: {
				position: 'absolute',
				zIndex: theme.zIndex.mobileStepper,
			},
			top: 0,
			bottom: 0,
			right: 0,
			left: 0,
			width: '100%',
			height: '100%',
			borderRadius: 0,
		},
		slideView_backdrop: {
			top: 0,
			bottom: 0,
			left: 0,
			right: 0,
			background: alpha(theme.palette.common.black, .4),
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				position: 'fixed',
				zIndex: theme.zIndex.tooltip,
			},
			[theme.breakpoints.up(BreakpointWidth.LARGE)]: {
				position: 'absolute',
				zIndex: theme.zIndex.mobileStepper,
			},
		}
	});
}

export default styles;